// Styles
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';

// Vuetify
import { createVuetify } from 'vuetify';

export default createVuetify({
  // Vuetify defaults `mobile` to anything under lg (1280px), which would push
  // small laptops into the collapsed-drawer layout. md (960px) is where this
  // layout actually runs out of room for a permanent drawer.
  display: {
    mobileBreakpoint: 'md',
  },

  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          background: '#e8ebf0', // Soft muted gray-blue (gentler than pure white)
          surface: '#d8dde4', // Balanced light gray-blue for cards
          primary: '#0457f1', // Vivid deep blue (emphasis, links)
          secondary: '#6494ed', // Cornflower blue (buttons, highlights)
          accent: '#d1d1cc', // Cool light gray (subtle highlights)
          // Same blue as `primary` here (already ~4.5:1 on this theme's
          // background/surface) - see the `dark` theme for why this is its
          // own token rather than reusing `primary` directly.
          link: '#0457f1',
          'on-link': '#ffffff',
        },
      },
      dark: {
        dark: true,
        colors: {
          background: '#1a1f2a', // Dark navy-gray (not pure black)
          surface: '#2b3240', // Charcoal with subtle blue tone
          primary: '#12429b', // Navy blue (buttons, highlights)
          secondary: '#0e61fb', // Bright royal blue (emphasis, links)
          accent: '#33332e', // Charcoal gray (subtle highlights)
          // `primary` is tuned to sit under white button text (9:1+ there)
          // which leaves it at only ~1.4:1 against `surface` - unreadable
          // as body text/icon color. `link` is the same hue, lifted to
          // ~4.9:1 against `surface` / ~6.3:1 against `background`, for
          // anywhere the color sits directly on the page rather than
          // behind white text.
          link: '#719ff4',
          // White text fails against `link` itself (~2.6:1) - the app's own
          // dark `background` tone reads clearly on it instead (~6.3:1).
          'on-link': '#1a1f2a',
        },
      },
    },
  },
});
